import type {ReactNode, KeyboardEvent} from 'react'
import {cn} from '@/lib/utils'

interface ExpandableRowProps {
    children: ReactNode
    onClick: () => void
    expanded?: boolean
    selected?: boolean
    className?: string
    'data-testid'?: string
}

export function ExpandableRow({
    children,
    onClick,
    expanded,
    selected,
    className,
    'data-testid': testId,
}: ExpandableRowProps) {
    const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            onClick()
        }
    }

    return (
        <div
            className={cn(
                'cursor-pointer hover:bg-muted/50 transition-colors',
                selected && 'bg-muted',
                className,
            )}
            onClick={onClick}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
            aria-expanded={expanded}
            data-testid={testId}
        >
            {children}
        </div>
    )
}
